import { render, staticRenderFns } from "./InspectionSendModal.vue?vue&type=template&id=987e28d2&scoped=true&"
import script from "./InspectionSendModal.vue?vue&type=script&lang=js&"
export * from "./InspectionSendModal.vue?vue&type=script&lang=js&"
import style0 from "./InspectionSendModal.vue?vue&type=style&index=0&id=987e28d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987e28d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987e28d2')) {
      api.createRecord('987e28d2', component.options)
    } else {
      api.reload('987e28d2', component.options)
    }
    module.hot.accept("./InspectionSendModal.vue?vue&type=template&id=987e28d2&scoped=true&", function () {
      api.rerender('987e28d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Inspection/InspectionSendModal.vue"
export default component.exports